import { createApp } from 'vue'
import App from './App.vue'
import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    legacy: false,
    locale: 'sv',
    fallbackLocale: 'sv',
    warnHtmlMessage: false,
    messages: {
        no: {
            "intro": {
                "text": "Noe i hvelvet påvirker avlingene.\n I dyrkingstelt B vokser plantene allerede dårligere, og problemet sprer seg. \nHvis årsaken ikke identifiseres raskt, risikerer hele matproduksjonen å bli ødelagt. \n<strong>Dere må planlegge en test umiddelbart før det er for sent</strong>."
            },
            "instructions": {
                "title": "Hva har skjedd i dyrkingstelt B?",
                "instructions": "I dyrkingstelt B vokser plantene dårligere. \n <strong>Dere tror det kan skyldes luftfuktigheten.</strong>",
                "subinstruction": "Nå skal dere teste om det stemmer – <strong>som ekte forskere</strong>.",
                "facts": {
                    "fact_1": "1. Hva skal varieres? \n Hva er det ENESTE dere endrer mellom teltene? \n(eksempel: Hvis dere vil teste lys → da endrer dere bare lyset og holder alt annet likt. ",
                    "fact_2": "2. Hva skal holdes likt? \n Hva må være nøyaktig det samme i begge teltene? \n(eksempel: Det må for eksempel være samme planter, hva mer må være likt?",
                    "fact_3": "3. Hvordan måler dere resultatet? \n Hvordan ser dere om plantene vokser bedre eller dårligere?",
                    "fact_4": "4. Hvordan gjør dere testen pålitelig? \n Hvordan kan dere være sikre på at resultatet er til å stole på? \n(eksempel: Man må for eksempel måle flere ganger, hva mer må man gjøre?",
                },
                "memo_prompt": "Memorerr dette og spill deretter inn alt du husker. Du vil ha 30 sekunder på deg.",
                "countdown_message": "Begynner innspilling om..."
            },
            "memory_test": {
                "title": "Hva har skjedd i dyrkingstelt B?",
                "description": "Du får 30 sekunder på deg til å huske 5 fakta, og deretter ytterligere 30 sekunder til å gjengi faktaene. Du får poeng basert på det og en kommentar om hvor bra du har lyktes.",
                "start_button": "Start"
            },
            "recording": {
                "prompt": "Fortell alt du husker!"
            },
            "analysis": {
                "analyzing": "Analyserer...",
                "status_prefix": "Status: ",
                "score_prefix": " av 100",
                "reset_button": "Start på nytt"
            },
            "status_messages": {
                "waiting_to_start": "Venter på å starte.",
                "error_prefix": "Feil ved gjenkjenning – ",
                "recording_in_progress": "Innspilling pågår...",
                "stopped_after_30s": "Innspilling stoppet etter 60 sekunder."
            }
        }

        ,
        sv: {
            "intro": {
                "text": "Något i valvet påverkar odlingarna.\n I Odlingstält B växer växterna redan sämre och problemet sprider sig. \nOm orsaken inte identifieras snabbt riskerar hela matproduktionen att slås ut. \n<strong>Ni måste planera ett test direkt innan det är för sent</strong>."
            },
            "instructions": {
                "title": "Vad har hänt i odlingstält B?",
                "instructions": "I odlingstält B växer växterna sämre. \n <strong>Ni tror det kan bero på luftfuktigheten.</strong>",
                "subinstruction": "Nu ska ni testa om det stämmer - <strong>som riktiga forskare</strong>.",
                "facts": {
                    "fact_1": "1. Vad ska varieras? \n Vad är det ENDA ni ändrar mellan tälten? \n(exempel: Om ni vill testa ljus → då ändrar ni bara ljuset och håller allt annat lika. ",
                    "fact_2": "2.Vad ska hållas lika? \n Vad måste vara exakt samma i båda tälten? \n(exempel: Det behöver till exempel vara samma växter, vad mer behöver vara samma?",
                    "fact_3": "3. Hur mäter ni resultatet? \n Hur ser ni om växterna växer bättre eller sämre?",
                    "fact_4": "4. Hur gör ni testet pålitligt? \n Hur kan ni vara säkra på att resultatet går att lita på? \n(exempel: Man behöver exempelvis mäta flera gånger, vad mer behöver man göra?",
                },
                "memo_prompt": "Memorera det här och spela sedan in allt du minns. Du kommer ha 30 sekunder på dig.",
                "countdown_message": "Börjar inspelning om..."
            },
            "memory_test": {
                "title": "Vad har hänt i odlingstält B?",
                "description": "Du får 30 sekunder på dig att komma ihåg 5 fakta och sen ytterligare 30 sekunder på dig att återge faktan. Du får sen poäng baserat på det och en kommentar kring hur bra du lyckats.",
                "start_button": "Starta"
            },
            "recording": {
                "prompt": "Berätta allt du kommer ihåg!"
            },
            "analysis": {
                "analyzing": "Analyserar...",
                "status_prefix": "Status: ",
                "score_prefix": " av 100",
                "reset_button": "Börja om"
            },

            "status_messages": {
                "waiting_to_start": "Väntar på att starta.",
                "error_prefix": "Fel vid igenkänning - ",
                "recording_in_progress": "Inspelning pågår...",
                "stopped_after_30s": "Inspelning stoppad efter 60 sekunder."
            }
        }
    }

})
const app = createApp(App)
app.use(i18n)
app.mount('#app')
